import { __awaiter } from "tslib";
import HTMLSanitizer from '@app/services/HTMLSanitizer';
export const GOOGLE_PROVIDER_NAME = "googleTranslate";
const googleTranslateApiUrlTemplate = (l1Code, l2Code, text) => `https://translate.googleapis.com/translate_a/t` +
    `?anno=3&client=te&format=html&v=1.0&key&sl=${l1Code}&tl=${l2Code}&sp=nmt&tc=1&tk=${calculateToken(text)}&mode=1`;
function calculateToken(text) {
    // tslint:disable-next-line: no-any
    function Eo(a, b) {
        for (let c = 0; c < b.length - 2; c += 3) {
            let d = b.charAt(c + 2);
            d = "a" <= d ? d.charCodeAt(0) - 87 : Number(d);
            // tslint:disable-next-line: no-bitwise
            d = "+" === b.charAt(c + 1) ? a >>> d : a << d;
            // tslint:disable-next-line: no-bitwise
            a = "+" === b.charAt(c) ? (a + d) & 4294967295 : a ^ d;
        }
        return a;
    }
    // tslint:disable-next-line: no-any
    function Fo(a, b) {
        let c = b.split(".");
        const d = [];
        let e = 0;
        let f = 0;
        b = Number(c[0]) || 0;
        for (e = 0, f = 0; f < a.length; f++) {
            let h = a.charCodeAt(f);
            // tslint:disable
            128 > h
                ? (d[e++] = h)
                : (2048 > h
                    ? (d[e++] = (h >> 6) | 192)
                    : (55296 == (h & 64512) &&
                        f + 1 < a.length &&
                        56320 == (a.charCodeAt(f + 1) & 64512)
                        ? ((h =
                            65536 +
                                ((h & 1023) << 10) +
                                (a.charCodeAt(++f) & 1023)),
                            (d[e++] = (h >> 18) | 240),
                            (d[e++] = ((h >> 12) & 63) | 128))
                        : (d[e++] = (h >> 12) | 224),
                        (d[e++] = ((h >> 6) & 63) | 128)),
                    (d[e++] = (h & 63) | 128));
        }
        a = b;
        for (e = 0; e < d.length; e++)
            (a += d[e]), (a = Eo(a, "+-a^+6"));
        a = Eo(a, "+-3^+b+-f");
        a ^= Number(c[1]) || 0;
        0 > a && (a = (a & 2147483647) + 2147483648);
        c = a % 1e6;
        return c.toString() + "." + (c ^ b);
        // tslint:enable
    }
    const seed = "433070.2418329410";
    return Fo(text, seed);
}
function processTranslationResults(result, wrapInLink) {
    const html = result
        .replace(/<i>[^<]*<\/i>/g, " ")
        .replace("<b>", "")
        .replace("</b>", "");
    return HTMLSanitizer.escapeLtGtHtml(html);
}
export const GoogleAutomaticTranslationProvider = (_a) => __awaiter(void 0, [_a], void 0, function* ({ l1Code, l2Code, text }) {
    if (!text || text.trim().length === 0) {
        return {
            provider: GOOGLE_PROVIDER_NAME,
            request: { l1Code, l2Code, text },
            result: {
                html: '',
                text: '',
                resultRaw: '',
            }
        };
    }
    const url = googleTranslateApiUrlTemplate(l1Code, l2Code, text);
    const translationResult = yield fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `q=${encodeURIComponent(text)}`,
    });
    const result = (yield translationResult.json()).toString();
    const resultText = unescape(result);
    return {
        provider: GOOGLE_PROVIDER_NAME,
        request: { l1Code, l2Code, text },
        result: {
            text: resultText,
            resultRaw: resultText,
            html: processTranslationResults(resultText, false),
        }
    };
});
